export const VendorElectronicFileTypesEnum = {
  FixedLength: 'F',
  CSV: 'C',
  XML: 'X',
  USFOOD: 'U',
  SYSCO: 'S',
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/VendorElectronicFileTypesEnum.js